import { Injectable } from '@angular/core';
import { IRsvpDetails, IRsvpVenueInfo, IWaiverFoundDetails } from './rsvp.model';
import { HttpClient } from '@angular/common/http';
import { InitialConfigService } from '@app/core/app-config/initial-config.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RsvpService {
  private uniqueBookingId = '';
  private rsvpVenueInfo: IRsvpVenueInfo = {} as IRsvpVenueInfo;

  constructor(
    private http: HttpClient,
    private initialConfigService: InitialConfigService
  ) {}

  /** Call when init, get the venue info*/
  loadRsvpVenueInfo(uniqueBookingId: string): Observable<IRsvpVenueInfo> {
    return this.http.get<IRsvpVenueInfo>(
      `${this.initialConfigService.getBaseApiUrl()}/bookings/${uniqueBookingId}/rsvp/`
    );
  }

  /** Call when user submit the RSVP */
  submitRsvp(rsvpDetails: IRsvpDetails, uniqueBookingId: string): Observable<undefined> {
    return this.http.post<undefined>(
      `${this.initialConfigService.getBaseApiUrl()}/bookings/${uniqueBookingId}/rsvp/`,
      rsvpDetails
    );
  }

  /** Call when user submit the RSVP, get existing waiver data */
  checkExistingWaiver(email: string, dob: string): Observable<IWaiverFoundDetails> {
    return this.http.post<IWaiverFoundDetails>(
      `${this.initialConfigService.getBaseApiUrl()}/waivers/signed/verification`,
      { email: email, dob: dob }
    );
  }

  setUniqueBookingIdSync(uniqueBookingId: string): void {
    this.uniqueBookingId = uniqueBookingId;
  }

  getUniqueBookingIdSync(): string {
    return this.uniqueBookingId;
  }

  setRsvpVenueInfoSync(rsvpVenueInfo: IRsvpVenueInfo): void {
    this.rsvpVenueInfo = rsvpVenueInfo;
  }

  getRsvpVenueInfoSync(): IRsvpVenueInfo {
    return this.rsvpVenueInfo;
  }
}
